import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class DeleteMagazineService {

  constructor(private http: HttpClient) { }

  async deleteMagazine(data) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "description": "application/json",
          "type": "text",
          "enabled": "true"
        })
      };
      let response = await this.http
        .post(`${appApiResources.deleteMagazine}`, data, httpOptions)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }
}